import { CalendarDateItem } from './calendarDateItem';
import { WEEK_LABEL } from '@/consts/bodyAndPaint';

interface CalendarDateEntryBodyProps {
  dateItemList: {
    dateLabel: string;
    selectStyle: string;
    reserveStyle: string;
    onClick: () => void;
  }[][];
}
export const CalendarDateEntryBody = ({
  dateItemList,
}: CalendarDateEntryBodyProps) => {
  return (
    <div className={'calendar-date-body'}>
      <div className={'calendar-label'}>
        {Object.keys(WEEK_LABEL).map((item, idx) => (
          <div className={`day-of-week ${item}`} key={idx}>
            {WEEK_LABEL[item as keyof typeof WEEK_LABEL]}
          </div>
        ))}
      </div>
      <div className={'calendar-field'}>
        {dateItemList?.map((weekItem, weekIdx) => (
          <div className={'week-item'} key={weekIdx}>
            {weekItem.map((dateItem, dateIdx) => (
              <CalendarDateItem key={dateIdx} props={dateItem} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
